import * as React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { showSearch } from 'state/actions/search';
import { getShown } from 'state/selectors/search';
import { fetchHelpCenterBrandingAction } from 'epics/model/help-center';
import { fetchUserModelAction } from 'epics/model/user';
import type { DumbProps } from '../header-dumb';
import { DumbHeader } from '../header-dumb';
import { isLoggedIn, isUserLoaded } from 'state/selectors/user';
import { isCustomizing } from 'state/selectors/help-center-preview';
import { fetchOrganisationsModelAction } from 'epics/model/organisations';
import type { State } from 'state';
import { getPathname, getPortalId } from 'state/selectors/context';
import { getLoginUrl } from 'util/url';
import { getOrganisations } from 'state/selectors/organisations';
import { getIsAnonymousEnabled } from 'state/selectors/env';
import { fetchUserRequestsCountsAction } from 'epics/model/user-requests-counts';
import { getUserRequestsCounts } from 'state/selectors/user-requests-counts';

interface Props extends DumbProps {
    isAnonymous?: boolean;
    /* eslint-disable @typescript-eslint/no-explicit-any */
    fetchBranding: () => any;
    fetchUser: typeof fetchUserModelAction;
    fetchUserRequestsCounts: typeof fetchUserRequestsCountsAction;
    fetchOrganisations: () => any;
    openSearch: () => any;
    /* eslint-enable @typescript-eslint/no-explicit-any */
    searchShown: boolean;
    isUserLoaded: boolean;
    userLoggedIn: boolean;
    customizing?: boolean;
    loginUrl: string;
    isAdvancedHelpCenter?: boolean;
}

const getHeaderLoginUrl = (state: State) => {
    const portalId = getPortalId(state);
    return getLoginUrl({
        portalId,
        isAbsolute: true,
        redirectUrl: getPathname(state),
    });
};

const userRequestsSelector = (state: State) => {
    return getUserRequestsCounts(state);
};

const selector = createSelector(
    getShown,
    isLoggedIn,
    getHeaderLoginUrl,
    isUserLoaded,
    isCustomizing,
    userRequestsSelector,
    getOrganisations,
    getIsAnonymousEnabled,
    (searchShown, userLoggedIn, loginUrl, userLoaded, customizing, userRequest, organisations, anonymousEnabled) => ({
        searchShown,
        userLoggedIn,
        loginUrl,
        userRequest,
        organisations,
        anonymousEnabled,
        isUserLoaded: userLoaded,
        isCustomizing: customizing,
    })
);

class Header extends React.Component<Props> {
    componentDidMount() {
        this.props.fetchBranding();
        if (!this.props.isAnonymous) {
            this.props.fetchUser();
            this.props.fetchOrganisations();
            this.props.fetchUserRequestsCounts();
        }
    }

    componentDidUpdate(prevProps: Props) {
        // If we haven't loaded the user yet and we've moved from an
        // anonymous route to a normal route, go fetch the user.
        if (!this.props.isUserLoaded && prevProps.isAnonymous && !this.props.isAnonymous) {
            this.props.fetchUser();
            this.props.fetchUserRequestsCounts();
        }
    }

    render() {
        return <DumbHeader {...this.props} />;
    }
}

export default connect(selector, {
    openSearch: () => showSearch(true),
    fetchBranding: fetchHelpCenterBrandingAction,
    fetchUser: fetchUserModelAction,
    fetchOrganisations: fetchOrganisationsModelAction,
    fetchUserRequestsCounts: fetchUserRequestsCountsAction,
})(Header);
